import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUserState, IUserAccount, IUserInfo, IUserSetting, INotifications } from "./interfaces";
import { DEFAULT_USER_STATE, INITIAL_USER_STATE } from "./constants";

const userSlice = createSlice({
	name: "user",
	initialState: INITIAL_USER_STATE,
	reducers: {
		setUser: (state: IUserState, action: PayloadAction<IUserInfo>) => {
			state.user = {
				...action.payload,
			};
		},
		unsetUser: (state: IUserState) => {
			state.user = { ...DEFAULT_USER_STATE.user };
			state.notifications = { ...DEFAULT_USER_STATE.notifications };
		},
		setAccounts: (state: IUserState, action: PayloadAction<Array<IUserAccount>>) => {
			state.accounts = [...action.payload];
		},
		setSettings: (state: IUserState, action: PayloadAction<Array<IUserSetting>>) => {
			state.settings = [...action.payload];
		},
		setSetting: (state: IUserState, action: PayloadAction<Pick<IUserSetting, "title" | "data" | "type">>) => {
			state.settings = state.settings.map(setting => {
				if (action.payload.title === setting.title) {
					return {
						...setting,
						data: {
							...action.payload.data,
						},
					};
				}

				return { ...setting };
			});
		},
		setNotifications: (state: IUserState, action: PayloadAction<INotifications>) => {
			state.notifications = { ...action.payload };
		},
	},
});

// dle "duck" metodiky jsou akce pojmenovane exporty a reducer default export
export const { setUser, unsetUser, setAccounts, setSettings, setSetting, setNotifications } = userSlice.actions;
export default userSlice.reducer;
